import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { useAuth } from '@shared/state/hooks/useAuth';
import { LowerRole } from '@shared/types';

import { callOrderListDataAtom, callOrderListStatusAtom } from './callOrder.atom';
import { CallOrderStatus } from './callOrder.interface';

export const callOrderListHookUrl = (role: LowerRole) => {
  return `/${role}/call-order/?${queryString({
    filter: {
      status: CallOrderStatus.Todo,
    },
    options: {
      sort: {
        createdAt: -1,
      },
    },
    populate: [
      {
        path: 'bugo',
        populate: [
          {
            path: 'fevent',
            populate: [
              {
                path: 'funeralHomeInfo',
              },
              {
                path: 'roomInfo',
              },
              //* 상조명 표기용 — 전체 문서는 무거우므로 이름 필드만 select
              {
                path: 'bugoBrand',
                select:
                  'type bugoAgency.nickName bugoAgency.corpName bugoAgencyList.nickName bugoAgencyList.corpName',
              },
            ],
          },
          {
            path: 'member',
          },
        ],
      },
      {
        path: 'shop',
      },
    ],
  })}`;
};

export const useCallOrderListHook = () => {
  const { isAdmin, isStoreSeller, sellerRole } = useAuth();
  useRecoilQuery(
    callOrderListStatusAtom,
    callOrderListDataAtom,
    callOrderListHookUrl(sellerRole()),
    fetcher,
    !(isAdmin() || isStoreSeller()),
  );
};
